<div class="modal-header bg-soft-info p-3">
    <h5 class="modal-title" id="exampleModalLabel" i18n="@@">Customize - {{newTableConfig.listTitle}}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>
<div class="card-body p-3">

    <div class="col-lg-12">
        <!-- <div class=" mb-3">
            <ngb-accordion #pageAccordion="ngbAccordion" class="accordion" role="tablist" aria-multiselectable="false">
                <ngb-panel class="accordion-item">
                    <ng-template ngbPanelTitle>
                        <a class="accordion-header" href="javascript:void(0);">

                            <div class="d-flex position-relative show" style="  z-index: 2;">
                                <h6 class="fs-14 mb-1">
                                    List Item Actions
                                </h6>
                            </div>
                        </a>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div style="margin-top: 1.25rem; margin-bottom: 1.25rem;" class="d-flex flex-wrap">
                                <div *ngFor="let action of newTableConfig.actions; index as i;"
                                    class="col-12 col-md-6 col-lg-4 mb-3">
                                    <div class="d-flex" style="color: var(--vz-accordion-color)">
                                        <i class="{{action.icon}} align-bottom me-2 text-muted"></i>
                                        {{action.label}}:
                                    </div>
                                    <div class="row flex">
                                        <label for="job_type-field" class="form-label">Show action in dropdown:</label>

                                        <div class="form-check form-switch ms-0 "
                                            style="padding-left: calc(var(--vz-gutter-x)* 0.5) !important;">
                                            <input class="form-check-input ms-0" type="checkbox"
                                                [checked]="action.inDropdown"
                                                (change)="action.inDropdown = !action.inDropdown" />
                                        </div>
                                    </div>
                                    <div class="row flex">
                                        <label for="job_type-field" class="form-label">Show action in list:</label>

                                        <div class="form-check form-switch ms-0 "
                                            style="padding-left: calc(var(--vz-gutter-x)* 0.5) !important;">
                                            <input class="form-check-input ms-0" type="checkbox"
                                                [checked]="action.inList" (change)="action.inList = !action.inList" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>

        </div>
        <div class=" mb-3">
            <ngb-accordion #pageAccordion="ngbAccordion" class="accordion" role="tablist" aria-multiselectable="false">
                <ngb-panel class="accordion-item">
                    <ng-template ngbPanelTitle>
                        <a class="accordion-header" href="javascript:void(0);">
                            <div class="d-flex position-relative show" style="  z-index: 2;">
                                <h6 class="fs-14 mb-1">
                                    Filter Options
                                </h6>
                            </div>
                        </a>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div style="margin-top: 1.25rem; margin-bottom: 1.25rem;"  class="d-flex flex-wrap">
                                <div *ngFor="let filter of newTableConfig.filters; index as i;"
                                    class="col-12 col-md-6 col-lg-4 mb-3">
                                    <div class="d-flex" style="color: var(--vz-accordion-color)">
                                        {{filter.label}}:
                                    </div>
                                    <div class="row flex">
                                        <label for="job_type-field" class="form-label">Show filter as dropdown:</label>

                                        <div class="form-check form-switch ms-0 "
                                            style="padding-left: calc(var(--vz-gutter-x)* 0.5) !important;">
                                            <input class="form-check-input ms-0" type="checkbox"
                                                [checked]="filter.inDropdown"
                                                (change)="filter.inDropdown = !filter.inDropdown" />
                                        </div>
                                    </div>
                                    <div class="row flex">
                                        <label for="job_type-field" class="form-label">Show filter as heading:</label>

                                        <div class="form-check form-switch ms-0 "
                                            style="padding-left: calc(var(--vz-gutter-x)* 0.5) !important;">
                                            <input class="form-check-input ms-0" type="checkbox"
                                                [checked]="filter.inHeading" (change)="filter.inHeading = !filter.inHeading" />
                                        </div>
                                    </div>
                                    <div class="row flex">
                                        <label for="job_type-field" class="form-label">Show filter as button dropdown:</label>

                                        <div class="form-check form-switch ms-0 "
                                            style="padding-left: calc(var(--vz-gutter-x)* 0.5) !important;">
                                            <input class="form-check-input ms-0" type="checkbox"
                                                [checked]="filter.inButton" (change)="filter.inButton = !filter.inButton" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div> -->
        <div *ngIf="tableConfig.enablePagination" class=" mb-3">
            <ngb-accordion #pageAccordion="ngbAccordion" class="accordion" role="tablist" aria-multiselectable="false"
                activeIds="static-1" [closeOthers]="true">
                <ngb-panel id="static-1" class="accordion-item">
                    <ng-template ngbPanelTitle>
                        <a class="accordion-header" href="javascript:void(0);">
                            <div class="d-flex position-relative show" style="  z-index: 2;">
                                <h6 class="fs-14 mb-1">
                                    General Options
                                </h6>
                            </div>
                        </a>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div style="margin-top: 1.25rem; margin-bottom: 1.25rem;" class="d-flex flex-wrap">
                                <div class="col-12 col-md-6 col-lg-4 mb-3">
                                    <div *ngIf="tableConfig.pageSizeFilter" class="dropdown" ngbDropdown>
                                        <div class="d-flex"
                                            style="margin-bottom: 0.5rem; color: var(--vz-accordion-color)">
                                            Page Size:
                                        </div>
                                        <app-ng-select-layout [(model)]="newTableConfig.pageSize"
                                            [items]="pageSizeFilterDropdownOptions"></app-ng-select-layout>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>

        </div>
        <div class=" mb-3">
            <ngb-accordion #pageAccordion="ngbAccordion" class="accordion" role="tablist" aria-multiselectable="false"
                activeIds="static-1">
                <ngb-panel id="static-1" class="accordion-item">
                    <ng-template ngbPanelTitle>
                        <a class="accordion-header" href="javascript:void(0);">
                            <div class="d-flex position-relative show" style="  z-index: 2;">
                                <h6 class="fs-14 mb-1">
                                    Columns
                                </h6>
                            </div>
                        </a>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div style="margin-top: 1.25rem; overflow:auto;">
                                <div class="d-flex justify-content-end pb-3">
                                    <button type="button" class="btn btn-primary " id="add-btn" (click)="addColumn()"
                                        i18n="@@">Add Column</button>
                                </div>
                            </div>
                            <div style="margin-bottom: 1.25rem; overflow:auto;">


                                <table class="table align-middle table-nowrap mb-0" style="min-height: 0rem;">
                                    <thead class="text-muted table-light">
                                        <tr>
                                            <th class="d-flex">

                                                <div style="width: 150px; margin-left: 5.5rem !important;">
                                                    Column Name
                                                </div>
                                                <div style="width: 125px; margin-left: 0.75rem !important;">
                                                    Is Visible
                                                </div>

                                                <div style=" width: 150px; margin-left: 0.75rem !important;">
                                                    Date Format
                                                </div>

                                                <div style=" width: 150px; margin-left: 0.75rem !important;">
                                                    Default Value
                                                </div>

                                                <div style="width: 150px; margin-left: 12rem !important;">
                                                    Actions
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
                                        <span *ngFor="let column of newTableConfig.columns; index as index;"
                                            [ngStyle]="{'display': (column.type == enumColumnType.CheckBox) ? 'none': 'block'} ">
                                            <div class="example-box" cdkDrag>
                                                <div *cdkDragPlaceholder
                                                    class="example-custom-placeholder  col-12  accordion-header d-flex align-items-center">

                                                    <div style="width: 150px; margin-left: 5rem !important;">
                                                        {{column.title}}
                                                    </div>

                                                </div>
                                                <div class="d-flex align-items-start" cdkDragHandle>
                                                    <div class="flex-shrink-0 me-3">
                                                        <div class="task-handle px-1 bg-light rounded"
                                                            style="font-size: 12px !important;">: :</div>
                                                    </div>
                                                </div>
                                                <div class="col-12  accordion-header d-flex align-items-center"
                                                    style="width: auto !important;">
                                                    <div style="width: 150px; margin-left: 2.5rem !important;">
                                                        <div *ngIf="column.type == enumColumnType.Action">
                                                            {{column.title}}
                                                        </div>
                                                        <div *ngIf="column.type != enumColumnType.Action">
                                                            <input [disabled]="column.isBeingInlineEdited != true"
                                                                class="form-control" [(ngModel)]="column.title" />
                                                        </div>

                                                    </div>
                                                    <div style="width: 75px; margin-left: 1.5rem !important;">
                                                        <div *ngIf="column.type != enumColumnType.Action"
                                                            class="form-check form-switch ms-0 "
                                                            style="padding-left: calc(var(--vz-gutter-x)* 0.5) !important;">
                                                            <input class="form-check-input ms-0" type="checkbox"
                                                                [checked]="getIfVisibleStatus(column.visible)"
                                                                (change)="column.visible = invertStringBoolean(column.visible)" />
                                                        </div>
                                                    </div>
                                                    <div style="width: 150px; margin-left: 1.5rem !important;">
                                                        <div
                                                            *ngIf="column.type == enumColumnType.Date && column.customDateDisplayOptionSelected != undefined">
                                                            <app-ng-select-layout [placeHolderText]="'Select an Option'"
                                                                [(model)]="column.customDateDisplayOptionSelected"
                                                                [items]="customDateDisplayOptions"></app-ng-select-layout>
                                                        </div>
                                                    </div>

                                                    <div style="width: 150px; margin-left: 1.5rem !important;">
                                                        <input
                                                            *ngIf="column.type == enumColumnType.CustomUserInputFromConfig"
                                                            [disabled]="column.isBeingInlineEdited != true"
                                                            class="form-control" [(ngModel)]="column.dataFieldName" />
                                                    </div>

                                                    <div style="width: 150px; margin-left: 13rem !important;">
                                                        <div *ngIf="column.isBeingInlineEdited != undefined"
                                                            class="align-items-end">
                                                            <ul class="list-inline hstack mb-0">
                                                                <span *ngFor="let action of customActions;">
                                                                    <li *ngIf="action.inList" class="ms-1">
                                                                        <button *ngIf="showAction(column,action)"
                                                                            (click)="onRowActionClicked(action.actionId,column); stopPropagationOnClick($event);"
                                                                            class="dropdown-item mr-1"
                                                                            href="javascript:void(0);"><i
                                                                                class="{{action.icon}} align-bottom me-2 text-muted"
                                                                                style="font-size: large;"></i>
                                                                        </button>
                                                                    </li>
                                                                </span>
                                                                <li class="list-inline-item ms-2">
                                                                    <div class="dropdown position-static" ngbDropdown
                                                                        style="z-index: 100;">
                                                                        <button
                                                                            class="btn btn-soft-secondary btn-sm dropdown arrow-none cursor-pointer"
                                                                            type="button" data-bs-toggle="dropdown"
                                                                            aria-expanded="false" ngbDropdownToggle>
                                                                            <i class="ri-more-fill align-middle"></i>
                                                                        </button>
                                                                        <ul class="dropdown-menu position-absolute"
                                                                            ngbDropdownMenu>
                                                                            <span *ngFor="let action of customActions"
                                                                                [ngStyle]="{'display': 
                                                                        (showAction(column,action)) ? '' :'none'} ">
                                                                                <li *ngIf="action.inDropdown">
                                                                                    <button
                                                                                        ngbTooltip="{{action.tooltip}}"
                                                                                        (click)="onRowActionClicked(action.actionId,column); stopPropagationOnClick($event);"
                                                                                        class="dropdown-item"
                                                                                        href="javascript:void(0);"><i
                                                                                            class="{{action.icon}} align-bottom me-2"
                                                                                            [ngClass]='customColorIcon(action.color)'></i>
                                                                                        {{action.label}}</button>
                                                                                </li>
                                                                            </span>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </span>
                                    </div>
                                </table>


                            </div>

                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
    </div>
    <div class="d-flex justify-content-between">
        <button *ngIf="defaultTableConfig != undefined" type="button" class=" btn btn-danger" id="add-btn"
            (click)="resetToDefaultList()" i18n="@@">Reset to defaults</button>
        <span *ngIf="defaultTableConfig == undefined"></span>
        <button type="button" class="btn btn-success " id="add-btn" (click)="onUpdate()" i18n="@@">Update</button>
    </div>
</div>